module.exports = __webpack_public_path__ + "static/media/bar0.dacabf84.svg";